import gsap from "gsap";
export default function Heropageblock() {
  Alpine.data("heropageblock", () => ({
    init() {
      gsap.matchMedia().add("(min-width: 1024px)", () => {
        this.animate();
      });
    },
    animate() {
      const media = this.$refs.media;
      const content = this.$refs.content;
      if (!media || !content || !media.children[0] || !media.children[1])
        return;

      const tl = gsap.timeline({ delay: 0.2 });

      // Overlay wipes down, revealing the image beneath
      tl.fromTo(
        media.children[0],
        { yPercent: 0 },
        { yPercent: -100, ease: "power4.out", duration: 0.9 },
      );

      // Image slides up into position, offset slightly behind the overlay
      tl.fromTo(
        media.children[1],
        { yPercent: 4 },
        { yPercent: 0, ease: "power4.out", duration: 0.9 },
        "<0.1",
      );

      // Content fades in after the reveal settles
      tl.fromTo(
        content,
        { opacity: 0 },
        { opacity: 1, ease: "power4.out", duration: 0.9 },
        "-=0.9",
      );
    },
  }));
}
